import { http } from "../http"

export default class CostFetchApi {
    static async getCostAdjustments(options = {}) {
        const response = await http.get("/cost-adjustments", {
            params: {
                page: options.page || 1,
                limit: options.limit || 10,
                search: options.search || undefined,
            },
        })
        return response.data
    }

    static async getCostAdjustmentDetails(id) {
        const response = await http.get(`/cost-adjustments/${id}`)
        return response.data
    }
}
